<template>
  <div :style="responsive ? 'width: 100%;' : ''">
    <svg
      ref="histogram"
      :width="responsive ? '100%' : w"
      :height="h"
      :viewBox="responsive ? `0 0 ${w} ${h}` : null"
      :preserveAspectRatio="responsive ? 'none' : null"
    >
      <!-- <g :transform="`translate(${margin.left}, ${margin.top})`"> -->
      <g>
        <rect
          v-for="(d, i) in data"
          :key="i"
          :x="xScale(d.value)"
          :y="yScale(d.count)"
          :width="xScale.bandwidth()"
          :height="h - yScale(d.count)"
          fill="#3F51B5"
        />
        <!-- TODO: Key needs to be random to fix pagination bug on table... -->
      </g>
    </svg>
  </div>
</template>

<script>
import { max } from 'd3-array';
import { scaleLinear, scaleBand } from 'd3-scale';
import { uniqueId } from 'lodash';

export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
    width: {
      type: Number,
      default: 100,
    },
    height: {
      type: Number,
      default: 25,
    },
    // Stretch to the container width via a viewBox. Off by default so the
    // fixed-size sparklines in the Variables tab are unaffected.
    responsive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: true,
      margin: {
        top: 2,
        right: 2,
        bottom: 2,
        left: 2,
      },
    };
  },
  computed: {
    w() {
      const { left, right } = this.margin;
      const { width } = this;
      return width - left - right;
    },
    h() {
      const { top, bottom } = this.margin;
      const { height } = this;
      return height - top - bottom;
    },
    xScale() {
      return scaleBand()
        .domain(this.data.map(d => d.value))
        .range([0, this.w])
        .padding(0.05);
    },
    yScale() {
      return scaleLinear()
        .domain([0, max(this.data, d => d.count)])
        .range([this.h, 0]);
    },
  },
  methods: {
    uniqueId,
  },
};
</script>

<style lang="scss" scoped></style>
